import { _enum, schema, string } from "@anna-money/anna-web-lib/serializer";

export enum FilledCompanyAttachmentType {
  PROOF_OF_ADDRESS = "PROOF_OF_ADDRESS",
  EXISTING_NAME_AUTHORISATION = "EXISTING_NAME_AUTHORISATION",
  COMPANY_NAME_AUTHORISATION = "COMPANY_NAME_AUTHORISATION",
}

export class AttachmentData extends schema(
  {
    companyId: string(),
    fileId: string(),
    type: _enum(FilledCompanyAttachmentType, "FilledCompanyAttachmentType"),
    directorId: string().optional(),
  },
  "AttachmentData",
) {}

export class AttachmentResponse extends schema(
  {
    attachmentId: string(),
  },
  "AttachmentResponse",
) {}
